/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of a VMware vSphere object.
 */
export enum BackupServerVmwareInventoryType {
    Unknown = 'Unknown',
    VirtualMachine = 'VirtualMachine',
    VCenterServer = 'vCenterServer',
    Datacenter = 'Datacenter',
    Cluster = 'Cluster',
    Host = 'Host',
    ResourcePool = 'ResourcePool',
    Folder = 'Folder',
    Datastore = 'Datastore',
    DatastoreCluster = 'DatastoreCluster',
    StoragePolicy = 'StoragePolicy',
    Template = 'Template',
    ComputeResource = 'ComputeResource',
    VirtualApp = 'VirtualApp',
    Tag = 'Tag',
    Category = 'Category',
    Multitag = 'Multitag',
    Network = 'Network'
};

